export default __webpack_public_path__ + "static/imda-logo-4c3c3710e803e140c59d0457bb0a7dfc.png";